import React from "react";
import logo from "./logo.svg";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home/Home";
import { ThemeProvider } from "@mui/material";
import theme from "./styles/theme";

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<h1>not fuoud</h1>} />
              {/* dashboard is under protected route, only logged in users can see it */}
              {/* <Route element={<ProtectedDashboard />}>
              <Route path="/dashboard" element={<Dashboard />} />;
            </Route> */}
            </Routes>
          </main>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
